<template>
    <div class="footer-content">
        <div class="pages">
            <div class="pages-list" v-for="item in pages" :key="item.index" @click="goToPage(item.path)">{{ item.name }}
            </div>
        </div>
        <img class="logo" src="@/assets/footer-logo.webp" alt="">
        <p>ZIELONY MOST PRIVATE LIMITED</p>
        <div class="contact">
            <div v-for="item in list" :key="item.index">
                <img :src="require('@/assets/footerIcon' + item.index + '.webp')" alt="">
                {{ item.content }}
            </div>
        </div>
        <div class="bottom">
            © 2025 Copyright belongs to ZIELONY MOST PRIVATE LIMITED
        </div>
    </div>
</template>
<script setup>
import { useRouter } from "vue-router";
const router = useRouter();
const list = [
    {
        content: "principal@zielony-most.com",
        index: 1,
    },
    {
        content: "400A, 4 Flr, 12 Ajit Sing, Yusuf Sarai Comm Comp., Green Park, New Delhi, Delhi 110016 IN",
        index: 2,
    },
    {
        content: "+91 7761973344",
        index: 3,
    },
];
const pages = [
    {
        name: "Pages",
    },
    {
        name: "Home",
        path: "/",
    },
    {
        name: "Services",
        path: "/service"
    },
    {
        name: "Introduction",
        path: "/about"
    },
    {
        name: "Contact",
        path: "/contact"
    },
];
const goToPage = (path) => {
    router.replace(path);
}
</script>
<style lang="less" scoped>
.footer-content {
    width: 100%;
    height: 298px;
    background: #24335E;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 30px 343px 20px;
    box-sizing: border-box;
    position: relative;
    z-index: 0;

    .pages {
        width: 60%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 31px;

        .pages-list {
            font-weight: bold;
            font-size: 11px;
            color: #FFFFFF;
            line-height: 15px;
            cursor: pointer;
        }
    }

    .logo {
        width: 51px;
        height: 51px;
        object-fit: contain;
    }

    p {
        font-weight: bold;
        font-size: 14px;
        color: #DCDCDC;
        line-height: 21px;
        margin-bottom: 26px;
    }

    .contact {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 38px;

        &>div:nth-child(2) {
            width: 293px;
        }

        div {
            display: flex;
            align-items: center;
            font-weight: 500;
            font-size: 12px;
            color: #DCDCDC;
            line-height: 12px;

            img {
                width: 27px;
                height: 27px;
                object-fit: contain;
                margin-right: 12px;
            }
        }
    }

    .bottom {
        font-weight: 500;
        font-size: 10px;
        color: #D7D7D7;
        line-height: 15px;
    }
}
</style>